import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useIsMobile } from "@/hooks/use-mobile";

const features = [
  {
    title: "🎯 Accurate Calculations",
    description: "Automatic chip-to-currency conversion ensures perfect payouts every time",
    content: "Set your buy-in ratio once, track multiple rebuys, and let SplitPot handle the math"
  },
  {
    title: "👥 Group Management", 
    description: "Organize your regular poker groups and track long-term performance",
    content: "Create groups, add players, and maintain game history across multiple sessions"
  },
  {
    title: "📊 Player Stats",
    description: "Comprehensive leaderboards and performance tracking", 
    content: "Track wins, losses, total games, and head-to-head performance over time"
  },
  {
    title: "📱 Mobile Ready",
    description: "Works perfectly on all devices during live games",
    content: "Track buy-ins and enter chip counts on the go with our responsive design"
  },
  {
    title: "📋 Game History",
    description: "Complete records of all past games and sessions",
    content: "Export summaries, add notes, and maintain detailed game logs"
  },
  {
    title: "🔒 Secure & Private",
    description: "Your poker data stays private and secure",
    content: "Bank-level security ensures your game data and group information stays protected"
  }
];

export const MobileFeatureCarousel = () => {
  const isMobile = useIsMobile();

  if (!isMobile) {
    // Desktop/tablet layout - original grid
    return (
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <Card key={index} className="border-border hover:shadow-lg transition-shadow">
            <CardHeader>
              <CardTitle className="text-primary">{feature.title}</CardTitle>
              <CardDescription>{feature.description}</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">{feature.content}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  // Mobile layout - carousel with 2 cards visible + preview
  return (
    <div className="relative">
      <Carousel
        opts={{
          align: "start",
          loop: true,
        }}
        className="w-full"
      >
        <CarouselContent className="-ml-2 md:-ml-4">
          {Array.from({ length: Math.ceil(features.length / 2) }).map((_, slideIndex) => (
            <CarouselItem key={slideIndex} className="pl-2 md:pl-4 basis-4/5">
              <div className="grid grid-cols-1 gap-4 scale-100">
                {features.slice(slideIndex * 2, slideIndex * 2 + 2).map((feature, cardIndex) => (
                  <Card key={cardIndex} className="border-border hover:shadow-lg transition-shadow">
                    <CardHeader className="pb-3">
                      <CardTitle className="text-primary text-lg">{feature.title}</CardTitle>
                      <CardDescription className="text-sm">{feature.description}</CardDescription>
                    </CardHeader>
                    <CardContent className="pt-0">
                      <p className="text-xs text-muted-foreground">{feature.content}</p>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="left-2" />
        <CarouselNext className="right-2" />
      </Carousel>
    </div>
  );
};